import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const Description = styled(Typography)(
  {
    fontSize: 14,
    fontWeight: 400,
    display: 'block',
    margin: 0
  },
  ({ theme }) => ({
    color: theme.palette.colors.midnightBlue
  })
);

export default Description;
